export module Interfaces {
  export interface IPersonYearPage {
    requestPayDetails: IPaymentRequestDetails;
    residentDetails: IResidentDetails;
    personRequestGeneralDetails: IPersonRequestGeneralDetails;
    files: Array<IFiles>;
    allNotDraftRequestsForYear:Array<any>;
    approvedRequestsWithSamePayNo:Array<string>;
  }

  export interface IPaymentRequestDetails {
    sendDate: string;
    approveDate: string;
    payDate: string;
    payMethodName: string;
    payMethodCode: string;
    payRefNo: string;
    signature: string;
    isLinkToPaymentSent: boolean;
    externalPayLink:string;
  }

  export interface IResidentDetails {
    residentFromDate: string;
    isPayWater: boolean;
    isPayArnona: boolean;
    isHaveAsset: boolean;
    noOfChildrenUpTo18: boolean;
    isChildrenInEducation: boolean;
    isPayRent: boolean;
    workPlaceAreaName: string;
    partnerWorkPlaceAreaName: string;
    personYearId: string;
    personEmail: string;
    requestEmail: string;
    isStudent: boolean;
    isSecurityForces: boolean;
    isSelfEmployed: boolean;
    paysNo: string;
    personPhoneNo: string;
    requestPhoneNo: string;
    personId: string;
  }

  export interface IPersonRequestGeneralDetails {
    idNo: string;
    firstName: string;
    lastName: string;
    isGreen: boolean;
    year: number;
    requestNo: number;
    statusName: string;
    statusCode: string;
    rejectReason: string;
    isManualRequest: boolean;
    formFileId: string;
    partnerIdNo: string;
    partnerPersonId: string;
    requestId: string;
    validiyApprovmentToDate: Date;
    validiyApprovmentFromDate: Date;
    isActiveRequest: boolean;
  }

  export class IFiles {
    code: string;
    comment: string;
    fileName: string;
    fileStatusId: string;
    fileTypeCode: string;
    fileTypeId: string;
    fileTypeName: string;
    id: string;
    isDraft: boolean;
    isNew: boolean;
    mimeType: string;
    requestId: string;
    statusById: string;
    statusCode: string;
    statusDate: string;
    statusName: string;
    version: string;
  }

  export interface IUserInfo {
    accessToken: string;
    displayName: string;
    userId: string;
    role: string;
  }

  export interface ICallResult {
    isSuccess: boolean;
    msgs: IMsgs;
    result: object;
  }

  export interface IMsgs {
    msgs: Array<IInfoMsg>;
    errors: Array<IErrorMsg>;
    hasErrors: boolean;
  }

  export interface IInfoMsg {
    msgCode: string;
    message: string;
  }

  export interface IErrorMsg {
    msgCode: string;
    message: string;
  }

  export interface IFormLayout {
    colCount: number;
    items: Array<IFormItem>;
    labelLocation: string;
    disabled: boolean;
    Id;
    Code: string;
    typeName: string;
    title: string;
  }

  export interface IFormItem {
    editorType;
    options;
    bindTo;
    visible;
    disabled;
    dataField;
    width;
    rtlEnabled;
    cssClass;
    mask;
    maskChar;
    min;
    max;
    dataSource;
    displayExpr;
    valueExpr;
    editorOptions;
    items: Array<IFormItem>;
    onValueChanged;
    onSelectionChanged;
    updateChangeOnServer: boolean;
    caption;
    colSpan;
  }
}
